"use client";
import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy, where, getCountFromServer } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import CategoryCard from './CategoryCard';

import { useNavigate } from 'react-router-dom';
import { useProducts } from '../ProductContext';

export default function CategoriesGrid() {
  const [cats, setCats] = useState(null);
  const [counts, setCounts] = useState({});
  const [q] = useState('');
  const navigate = useNavigate();
  const { getCategoriesCache, setCategoriesCacheData } = useProducts();

  useEffect(() => {
    // Check cache first
    const cached = getCategoriesCache();
    if (cached && cached.categories.length > 0) {
      setCats(cached.categories);
      setCounts(cached.counts);
      return;
    }

    // No cache - fetch from Firestore
    const col = collection(db, 'categories');
    const qq = query(col, orderBy('name'));

    getDocs(qq)
      .then(async (catsSnap) => {
        const arr = catsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        setCats(arr);

        // Fetch counts for each category using countFromServer
        const countsMap = {};
        const prodCol = collection(db, 'products');

        await Promise.all(arr.map(async (cat) => {
          try {
            const countQuery = query(prodCol, where('category', '==', cat.name));
            const snapshot = await getCountFromServer(countQuery);
            countsMap[cat.name.toLowerCase().trim()] = snapshot.data().count;
          } catch (err) {
            console.error(`Error fetching count for ${cat.name}:`, err);
            countsMap[cat.name.toLowerCase().trim()] = 0;
          }
        }));

        setCounts(countsMap);

        // Save to cache
        setCategoriesCacheData(arr, countsMap);
      })
      .catch(err => { console.error(err); setCats([]); });
  }, [getCategoriesCache, setCategoriesCacheData]);

  const handleClick = (category) => {
    if (!category) return;
    navigate(`/collections?category=${encodeURIComponent(category.name)}`);
  };

  const filtered = Array.isArray(cats) ? cats.filter(c => c.name.toLowerCase().includes(q.toLowerCase())) : [];

  if (cats === null) {
    return (
      <div className="container px-3 px-md-4">
        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="col">
              <div className="category-card" style={{ pointerEvents: 'none' }}>
                <div className="card-media skeleton-bg"></div>
                <div className="category-info w-100 mt-2" style={{ gap: '8px' }}>
                  <div className="skeleton-bg mx-auto" style={{ height: '24px', width: '70%', borderRadius: '4px' }}></div>
                  <div className="skeleton-bg mx-auto" style={{ height: '14px', width: '40%', borderRadius: '4px' }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="container px-3 px-md-4">
      <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-2 justify-content-center">
        {filtered.map(c => {
          const norm = (s) => (s || '').toLowerCase().trim();
          const count = counts[norm(c.name)] ?? 0;
          return (
            <div key={c.id} className="col d-flex justify-content-center align-items-stretch">
              <CategoryCard category={{ ...c, count }} onClick={handleClick} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
